module.exports = __webpack_public_path__ + "static/media/Stripe.2746ac4e.svg";